export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14358.82c446e5.jpg";